import styled from 'styled-components';

import { Grid, media } from '@simplywallst/ui-core';

import { WarningSolid } from '@simplywallst/ui-core/icons';

export const StyledGrid = styled(Grid)`
  margin-top: ${({ theme }) => theme.x2spacePx}px;
  ${media.lgUp`
    margin-top: 0;
  `}
`;

export const Warning = styled('span')`
  position: relative;
  &:before {
    content: '';
    position: absolute;
    display: block;
    background-color: ${({ theme }) => theme.color.white};
    border-radius: ${({ theme }) => theme.x3spacePx}px;
    width: 12px;
    height: 12px;
    margin: 5px;
  }
`;

export const WarningIcon = styled(WarningSolid)`
  position: relative;
`;
